export const updatePostalCodeStatus = async (
  postalCode: string,
  country: string,
  validator: {
    validate?: {
      maxLength?: (postalCode: string) => string | null;
      pattern?: (postalCode: string) => string | null;
    };
  },
  postalCodeCheck: (postalCode: string, country: string) => Promise<string | null>,
  setPostalCodeStatus: React.Dispatch<React.SetStateAction<string | null>>,
) => {
  setPostalCodeStatus(null);

  if (!postalCodeCheck || !postalCode || !country) {
    return;
  }

  if (validator?.validate?.maxLength) {
    const postcodeLengthError = validator.validate.maxLength(postalCode);
    if (postcodeLengthError) {
      return;
    }
  }

  if (validator?.validate?.pattern) {
    const postcodePatternError = validator.validate.pattern(postalCode);
    if (postcodePatternError) {
      return;
    }
  }

  try {
    const status = await postalCodeCheck(postalCode, country);
    setPostalCodeStatus(status);
  } catch {
    // Ignore errors - postalCodeStatus will remain as null
  }
};
